import { render, staticRenderFns } from "./DetailSharePop.vue?vue&type=template&id=47822a02&"
import script from "./DetailSharePop.vue?vue&type=script&lang=js&"
export * from "./DetailSharePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports